import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconMarkersBlueSizeS from './IconMarkersBlue_size_s';

const props: CreateIconArguments = {
  l: IconMarkersBlueSizeS,
  m: IconMarkersBlueSizeS,
  s: IconMarkersBlueSizeS,
  xs: IconMarkersBlueSizeS,
  name: 'IconMarkersBlue',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
